<template>
  <div id="app">
    <v-app>
      <Header />
      <Navigation />
      <Filters />
      <router-view />
      <Footer />
    </v-app>
  </div>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto+Slab");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800");
@import "~vuetify/dist/vuetify.min.css";
@import "~leaflet/dist/leaflet.css";
</style>

<script>
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Filters from "./components/Filters";
import Footer from "./components/Footer";
import $data from "@/services/data.services.js";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Navigation,
    Filters
  },
  data() {
    return {
      //
    };
  },
  async created() {
    await $data.getData();
    await $data.getOptions();
  }
};
</script>
